import React from "react";
import * as TooltipPrimitives from "@radix-ui/react-tooltip";

export const SIMPLE_TOOLTIP_CONTENT_BASE_CLASS_NAME =
  "z-50 w-max max-w-[calc(100vw-2rem)] rounded-md border border-zinc-950 bg-zinc-950 px-2 py-1.5 font-normal leading-5 text-zinc-200 shadow-xl";
export const SIMPLE_TOOLTIP_CONTENT_CLASS_NAME = `${SIMPLE_TOOLTIP_CONTENT_BASE_CLASS_NAME} text-sm`;
export const RICH_TOOLTIP_CONTENT_CLASS_NAME =
  "z-50 w-72 animate-fade-in rounded-md border border-zinc-950 bg-zinc-950 px-3 py-2.5 text-sm text-zinc-200 shadow-xl";
export const TOOLTIP_ARROW_CLASS_NAME = "fill-zinc-950";

export const DisabledActionTooltip: React.FC<{
  message?: string;
  children: React.ReactNode;
  className?: string;
  stopPropagation?: boolean;
}> = ({
  message,
  children,
  className = "inline-flex cursor-not-allowed",
  stopPropagation = false,
}) => {
  if (!message) return <>{children}</>;

  const stopEventPropagation = (event: React.SyntheticEvent) => {
    if (stopPropagation) event.stopPropagation();
  };

  return (
    <TooltipPrimitives.Provider delayDuration={150} skipDelayDuration={100}>
      <TooltipPrimitives.Root>
        <TooltipPrimitives.Trigger asChild>
          <span
            className={className}
            tabIndex={0}
            onClick={stopEventPropagation}
            onKeyDown={stopEventPropagation}
          >
            {children}
          </span>
        </TooltipPrimitives.Trigger>
        <TooltipPrimitives.Portal>
          <TooltipPrimitives.Content
            data-testid="simple-tooltip-content"
            side="top"
            sideOffset={6}
            collisionPadding={8}
            className={SIMPLE_TOOLTIP_CONTENT_CLASS_NAME}
          >
            {message}
            <TooltipPrimitives.Arrow className={TOOLTIP_ARROW_CLASS_NAME} />
          </TooltipPrimitives.Content>
        </TooltipPrimitives.Portal>
      </TooltipPrimitives.Root>
    </TooltipPrimitives.Provider>
  );
};
